import { Component, OnInit, ViewChild, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { Router, ActivatedRoute } from '@angular/router';
import { constants } from '@assets/data/constants';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { tctd_editorConfig } from '@app/_constants';
import { TestdataCodemirrorDialogComponent } from '../../testdata-codemirror-dialog/testdata-codemirror-dialog.component';

@Component({
  selector: 'app-new-endpointflow',
  templateUrl: './new-endpointflow.component.html',
  styleUrls: ['./new-endpointflow.component.less']
})
export class NewEndpointflowComponent implements OnInit, OnDestroy {
  @Output() bodyTypeEditOptionVal = new EventEmitter<any>();
  @Output() updateBulkValue = new EventEmitter<any>();
  @Output() updateRequestBulkValue = new EventEmitter<any>();
  @Output() updateBodyFormDataBulkValue = new EventEmitter<any>();
  @Input() endpointForm: any = FormGroup;
  @Input() submitted: any;
  @Input() projectConfiguration: any;
  @Input() endpointModalEdited: any;

  readonly BULK = 'bulk';
  readonly KEYVAL = 'keyval';
  readonly MULTIPART = 'multipart';
  readonly BINARY = 'binary';
  readonly RAW = 'raw';
  readonly FORMDATA = 'form-data';
  readonly GRAPHQL = 'graphql';

  activeTabId = '0';
  configure: any;
  requestHeadersBulk = '';
  headers: any = {};
  params: any = {};
  formParams: any = {};
  requestParamsBulk = '';
  headerEditOption = this.KEYVAL;
  paramsEditOption = this.KEYVAL;
  formParamsEditOption = this.KEYVAL;
  bodyTypeEditOption: any;
  bodyFormDataBulk = '';
  requestBodyBulk = '';
  bodyBulk = '';
  customHeadersValues = [];
  multipart: any = {};
  queryParams: any;
  constants = constants;
  closeResult: string;
  editedHeaderIndex = 0;
  isEditedHeader = false;
  selectedResponseType = '';
  editedParamIndex = 0;
  isEditedParam = false;

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    public modalService: NgbModal
  ) { }

  codeMirrorOptions: any = tctd_editorConfig;
  @Input() endpointDetails: any = {};


  ngOnInit() {
    this.bodyTypeEditOption = this.FORMDATA;
    this.getConfigDefaultValues();
    if (this.route.snapshot.routeConfig?.path === ':id/edit') {
      this.endpointDetails = this.route.snapshot.data['details'].response; /* Endpoint details */

      this.getEndpointById(this.endpointDetails);
    }

    this.endpointForm.get('endPointType')?.valueChanges.subscribe((value) => {
      if (value.name === 'REST') {
        this.bodyTypeEditOption = this.FORMDATA;
        this.bodyTypeEditOptionData(this.FORMDATA);
      } else if (value.name === 'GRAPHQL') {
        this.bodyTypeEditOption = this.GRAPHQL;
        this.bodyTypeEditOptionData(this.GRAPHQL);
      }
    });

  }
  get f() { return this.endpointForm.controls; }

  setForm() {
    this.endpointForm = this.formBuilder.group({
      threshold: [''],
      endPointType: ['', Validators.required],
      environmentSpecific: [true],
      followRedirects: [true],
      sanitizeJsonResponse: [false],
      eventStreamTimeout:[null],
      eventStreamInterruptKeyword:[null]
    });
  }

  getConfigDefaultValues(): void {
    const about = localStorage.getItem('about');
    this.configure = {
      requestTypes: JSON.parse(about).requestTypes,
      responseTypes: JSON.parse(about).responseTypes
    };
    this.customHeadersValues = JSON.parse(about).headerValueMap['Content-Type'];
  }
  bodyTypeEditOptionData(data) {
    this.bodyTypeEditOptionVal.emit(data);
  }
  /* Getting endpoint details by id */
  private getEndpointById(data): void {
    this.selectedResponseType = data.responseType;
    this.endpointForm.patchValue({
      ...data,
      binaryData: data.binaryData || {},
      multiPartFormData: data.multiPartFormData || {}
    });
    if (data.requestBody) { this.bodyTypeEditOption = this.RAW; }
    if (data.binaryData) { this.bodyTypeEditOption = this.BINARY; }
    if (data.graphQLParams) { this.bodyTypeEditOption = this.GRAPHQL; }
    if (data.multiPartFormData) { this.bodyTypeEditOption = this.MULTIPART; }
    this.setEndpointFormValues(data);
  }

  setEndpointFormValues(obj): void {
    if (obj.requestParams != {}) { this.queryParamsInLine(obj.requestParams); }
  }

  /**
   * Changes edit options
   * @param checkBoxName
   * @param modelName
   * @param name
   */
  changeEditOptions(checkBoxName, modelName, name) {
    if (this[checkBoxName] == this.BULK) {
      this[modelName] = JSON.stringify(this.endpointForm.value[name]);
    } else if (this[checkBoxName] == this.KEYVAL) {
      if (this[modelName] == "") {
        this.endpointForm.controls[name].setValue({});
      } else {
        this.endpointForm.value[name] = JSON.parse(this[modelName]);
      }
    }
    if (checkBoxName === 'paramsEditOption') { this.queryParamsInLine(this.endpointForm.value[name]); }
  }

  addHeaders(obj): void {
    if (Object.keys(obj).length == 0) {
      this.toastr.error('Please enter some values');
      return;
    }
    if (!obj.key) {
      this.toastr.error('Please add key');
      return;
    }
    if (!obj.val) {
      this.toastr.error('Please add value to the key');
      return;
    }
    this.endpointForm.value.requestHeaders[obj.key] = obj.val;
    this.headers = {};
  }

  addParams(obj): void {
    if (Object.keys(obj).length == 0) {
      this.toastr.error('Please enter some values');
      return;
    };
    if (!obj.key) {
      this.toastr.error('Please add key');
      return;
    }
    if (!obj.val) {
      this.toastr.error('Please add value to the key');
      return;
    }
    this.endpointForm.value.requestParams[obj.key] = obj.val;
    this.queryParamsInLine(this.endpointForm.value.requestParams);
    this.params = {};
  }

  addFormParams(obj) {
    if (Object.keys(obj).length == 0) {
      this.toastr.error('Please enter some values');
      return;
    };
    if (!obj.key) {
      this.toastr.error('Please add key');
      return;
    }
    if (!obj.val) {
      this.toastr.error('Please add value to the key');
      return;
    }
    if (this.endpointForm.value.formParams == null) { this.endpointForm.value.formParams = {}; }
    this.endpointForm.value.formParams[obj.key] = obj.val;
    this.formParams = {};
  }

  editFormHeaders(obj, key, index) {
    this.editedHeaderIndex = index;
    this.headers.key = key;
    this.headers.val = obj[key];
    this.isEditedHeader = true;
  }

  updateFormHeader() {
    this.endpointForm.value.requestHeaders[this.headers.key] = this.headers.val;
    this.headers.key = null;
    this.headers.val = null;
    this.isEditedHeader = false;
  }

  editFormParam(obj, key, index) {
    this.editedParamIndex = index;
    this.params.key = key;
    this.params.val = obj[key];
    this.isEditedParam = true;
  }

  updateFormParam() {
    this.endpointForm.value.requestParams[this.params.key] = this.params.val;
    this.queryParamsInLine(this.endpointForm.value.requestParams);
    this.params.key = null;
    this.params.val = null;
    this.isEditedParam = false;
  }

  editFormParams(obj, key, index) {
    const modalRefPrimary = this.modalService.open(
      TestdataCodemirrorDialogComponent,
      {
        ariaLabelledBy: "modal-basic-title",
        backdrop: true,
        centered: true,
        size: "lg",
      }
    );

    modalRefPrimary.result.then(
      (result) => {
        if (result !== undefined) {
          this.endpointForm.value.formParams[key] = result;
        }
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason.emit(reason)}`;
      }
    );

    modalRefPrimary.componentInstance.testdataValue = obj[key];
    modalRefPrimary.componentInstance.title = "Form Data Value";
  }

  addMulitpart(obj) {
    if (Object.keys(obj).length == 0) {
      this.toastr.error('Please enter some values');
      return;
    }
    if (!obj.key) {
      this.toastr.error('Please add key');
      return;
    }
    if (!obj.contentType) {
      this.toastr.error('Please select a content type');
      return;
    }
    if (!obj.value) {
      this.toastr.error('Please add value to the key');
      return;
    }
    if (this.endpointForm.value.multiPartFormData.formDataParts == null) { this.endpointForm.value.multiPartFormData.formDataParts = []; }
    this.endpointForm.value.multiPartFormData.formDataParts.push(obj);
    this.multipart = {};
  }

  /**
   * Querys params in line
   * @param obj
   * @returns params in line
   */
  queryParamsInLine(obj): void {
    if (!obj) return;
    let string = "";
    for (const key in obj) {
      string += key + "=" + obj[key] + "&";
    }
    this.queryParams = string.substring(0, string.length - 1);
  }

  /**
   * Converting querparmas to json to show in table
   * @param str
   * @returns params to json
   */
  queryParamsToJson(str: string): void {
    if (!str || str === "") { return; }
    const jsonStr = str.split('&');
    for (let index = 0; index < jsonStr.length; index++) {
        const [key, ...rest] = jsonStr[index].split('=');
        const value = rest.join('=');
        this.endpointForm.value.requestParams[key] = value;
    }
  }

  deleteKeyValueParamsCommon(obj, key, type?, index?: number): void {
    if (Object.keys(obj).length === 0) { return; }
    delete (obj[key]);
    if (type == 'multipart') {
      obj.splice(index, 1);
    }
  }

  editKeyValueParamsCommon(obj, key, type?, index?: number) {
    const modalRefPrimary = this.modalService.open(
      TestdataCodemirrorDialogComponent,
      {
        ariaLabelledBy: "modal-basic-title",
        backdrop: true,
        centered: true,
        size: "lg",
      }
    );

    modalRefPrimary.result.then(
      (result) => {
        if (result !== undefined) {
          this.endpointForm.value.multiPartFormData.formDataParts[index].value = result;
        }
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason.emit(reason)}`;
      }
    );

    modalRefPrimary.componentInstance.testdataValue = obj[index].value;
    modalRefPrimary.componentInstance.title = "Multipart Value";
  }


  setEmptyCodemirror(name: string, obj: string) {
    if (obj == undefined || obj == '') {
      this[name] = '{}';
      if(name === 'requestParamsBulk'){
        this.endpointForm.value.requestParams = {};
      } else if (name === 'requestHeadersBulk') {
        this.endpointForm.value.requestHeaders = {};
      }
    }
  }



  onReset(): void {
    this.submitted = false;
    this.endpointForm.reset();
  }

  open(content: any): void {
    this.modalService.open(content, { windowClass: 'modal-holder', backdrop: 'static', size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  updateBulkParent() {
    this.updateBulkValue.emit(this.requestHeadersBulk);
  }
  updateRequestBulkParent(){
    this.updateRequestBulkValue.emit(this.requestParamsBulk);
  }
  updateBodyFormDataBulkParent(){
    this.updateBodyFormDataBulkValue.emit(this.bodyFormDataBulk);
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  onResponseTypeChange() {
    const selectedType = this.endpointForm.get('responseType')?.value;
    this.selectedResponseType = selectedType;
    if (selectedType !== 'EVENT_STREAM') {
      this.endpointForm.get('eventStreamTimeout')?.reset();
      this.endpointForm.get('eventStreamInterruptKeyword')?.reset();
    }
  }

  search = (text$: Observable<string>) => text$.pipe(debounceTime(200), distinctUntilChanged(),
    map(term => term.length < 2 ? [] : this.customHeadersValues.filter(v =>
      v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
    ))

  ngOnDestroy() {
    console.log();
    // this.modalService.dismissAll();
  }

}
